module.exports = __webpack_public_path__ + "static/img/refund_on.c5e283b6.svg";